<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-12" v-if="Object.keys(terminal).length">
                    <h6>اطلاعات کلی پایانه</h6>
                    <table class="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <td>نام</td>
                                <td>{{ terminal.terminalInfo.name }}</td>
                            </tr>
                            <tr>
                                <td>نام خانوادگی</td>
                                <td>{{ terminal.terminalInfo.last_name }}</td>
                            </tr>
                            <tr>
                                <td>عنوان پذیرنده</td>
                                <td>{{ terminal.terminalInfo.merchant_name }}</td>
                            </tr>
                            <tr>
                                <td>شمارهه پایانه</td>
                                <td>{{ terminal.terminalInfo.terminal_number }}</td>
                            </tr>
                            <tr>
                                <td>شماره پذیرنده</td>
                                <td>{{ terminal.terminalInfo.merchant_number }}</td>
                            </tr>
                            <tr>
                                <td>وضعیت</td>
                                <td>{{ terminal.terminalInfo.contract_status_desc }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <h6>شماره کارت های متصل به پایانه</h6>
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>شماره کارت</th>
                                <th>وضعیت</th>
                                <th>درصد</th>
                                <th>عملیات</th>
                                <th>گزارشات</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(card,index) in terminal.cards" :key="index">
                                <td>{{ card.card }}</td>
                                <td>{{ card.isActive ? 'فعال' : 'غیرفعال' }}</td>
                                <td>{{ card.percent }}%</td>
                                <td v-if="card.isActive">
                                    <button class="btn btn-danger btn-icon" @click="changeRowStatus(card.card,card.isActive)"><i class="fe fe-x"></i></button>
                                </td>
                                <td v-else>
                                    <button class="btn btn-success btn-icon" @click="changeRowStatus(card.card,card.isActive)"><i class="fe fe-check"></i></button>
                                </td>
                                <td >
                                   <router-link class="d-inline-block ml-2 btn "
                                        v-if="$store.state.role == 'admin' || $store.state.role == 'organization'"
                                        :to="{name: 'card.charge.report.id' , params : {id:card.card }}">شارژ کارت</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'create',
    data(){
        return {
            showLoading: true,
            terminal: {}
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const terminal = this.$route.params.id;
            this.$api.get(`MosqueOrganization/ReturnTerminalHistory?TerminalNumber=${terminal}`).then(({ data }) => {
                if(data.status){
                    this.terminal = data.result.terminal;
                }
            }).finally(() => {
                this.showLoading = false;
            })
        },
        changeRowStatus(cardNo,isActive){
            this.showLoading = true;
            if(isActive){
                this.$api.post('MosqueOrganization/DeActiveCard',{cardNumber: cardNo}).then(({ data }) => {
                    if(data.status){
                        this.$swal({
                            icon: 'success',
                            title: 'تبریک !',
                            text: 'وضعیت کارت با موفقیت به روزرسانی شد',
                        }).then(res => {
                            if(res.isConfirmed){
                                this.getData();
                            }
                        });
                    }
                }).finally(() => {
                    this.showLoading = false;
                })
            }else{
                this.$api.post('MosqueOrganization/ActiveCard',{cardNumber: cardNo}).then(({ data }) => {
                    if(data.status){
                        this.$swal({
                            icon: 'success',
                            title: 'تبریک !',
                            text: 'وضعیت کارت با موفقیت به روزرسانی شد',
                        }).then(res => {
                            if(res.isConfirmed){
                                this.getData();
                            }
                        });
                    }
                }).finally(() => {
                    this.showLoading = false;
                })
            }
        }
    },
    created(){
        this.getData();
    }
}
</script>